import React, { useMemo } from "react";
import { useDropzone } from "react-dropzone";
import { NavLink, useNavigate } from "react-router-dom";
import Papa from "papaparse";
import axios from "axios";
import mime from "mime";
import GLOBALS from "../../utils/Globals";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Badge from "react-bootstrap/Badge";

//import mime from "mime-types";

const maxLength = 20;
var filename = "";
var username = "";
var mts = "";

const allowedExtensions = ["csv,pdf,xlsx,xls"];

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#353b48",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
};

const files = [];

function pushIfNotDuplicate(element) {
  if (!files.includes(element)) {
    files.push(element);
  }
}

function nameLengthValidator(file) {

  console.log("nameLengthValidator");
  console.log(file.name);
  const inputFile = file.name;
  filename = file.name;

  console.log(files);
  pushIfNotDuplicate(filename);

  console.log(files);

  username = localStorage.getItem("userInfo");
  const obj = JSON.parse(username);
  //setUrl_Mod(url + obj.userFound.email);

  const formData = new FormData();
  formData.append("file", file);
  formData.append("username", obj.userFound.email);

  const fileType = "";
  var mime_type_sel = "";

  console.log(file.name)
  const mimeType = mime.getType(file.name);
  console.log("File MIME type:", mimeType);
  if (mimeType == "application/pdf") {
    console.log("pdf");
    mts = "pdf";

    // TODO PDF
  } else if (mimeType == "text/csv") {
    console.log("csv");
    mts = "csv";

    // upload the file to flask server
    // TODO upload to AWS s3
    axios
      .post(GLOBALS.DEV.dropMeJobs3, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        // handle the response
        console.log(response.data);
        console.log(response.data.uid);
        console.log(response.data._id);
        localStorage.setItem("manuuid", response.data.uid);
        localStorage.setItem("tuid", response.data.uid);
        //localStorage.setItem("_id", response.data._id);
      })
      .catch((error) => {
        // handle errors
        console.log(error);
      });

    // check for headers
    const reader = new FileReader();
    reader.onload = async ({ target }) => {
      const csv = Papa.parse(target.result, {
        header: true,
      });
      const parsedData = csv?.data;
      const rows = Object.keys(parsedData[0]);

      const columns = Object.values(parsedData[0]);
      const res = rows.reduce((acc, e, i) => {
        return [...acc, [[e], columns[i]]];
      }, []);
    };
  } else if (
    mimeType ==
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  ) {
    console.log("xlsx");
    mts = "xlsx";

    // upload the file to flask server
    // TODO upload to AWS s3
    axios
      .post(GLOBALS.DEV.dropMeJobsXLSX, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        // handle the response
        console.log(response.data);
        console.log(response.data.uid);
        console.log(response.data._id);
        localStorage.setItem("manuuid", response.data.uid);
        localStorage.setItem("tuid", response.data.uid);
        //localStorage.setItem("_id", response.data._id);
      })
      .catch((error) => {
        // handle errors
        console.log(error);
      });
  } else if (mimeType == "application/vnd.ms-excel") {
    console.log("xls");
    mts = "xls";

    // TODO XLS
  } else if (mimeType == "text/plain") {

    console.log("txt");
    mts = "txt";

    // upload the file to flask server
    // TODO upload to AWS s3
    axios
      .post(GLOBALS.DEV.dropMeJobsTXT, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        // handle the response
        console.log(response.data);
        console.log(response.data.uid);
        console.log(response.data._id);
        localStorage.setItem("manuuid", response.data.uid);
        localStorage.setItem("tuid", response.data.uid);
        //localStorage.setItem("_id", response.data._id);
      })
      .catch((error) => {
        // handle errors
        console.log(error);
      });

    // // rename files here
    // //
    // //
    // console.log(files);
    // axios.get(GLOBALS.DEV.rename_files + "/" + files).then((response) => {
    //   //setCount(response.data);
    //   console.log(response.data);
    // });
    // //GLOBALS.DEV.rename_files

    // TODO TXT
  } else {
    console.log("other");

    // TODO other
  }

  return null;
}

export default function CustomValidation(props) {
  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    multiple: true,
    // accept: {
    //    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
    //    "text/csv": [],
    //    "application/pdf": [],
    //    "text/plain": []
    //  },
    validator: nameLengthValidator,
  });

  console.log(files);

  const jsonArray = JSON.stringify(files);

  //localStorage.setItem("manufile", "");
  localStorage.setItem("manufile", jsonArray);

  console.log(mts);

  const acceptedFileItems = acceptedFiles.map((file) => (
    <>
      <Badge bg="success">Success</Badge>&nbsp;&nbsp;Ready to import file -{" "}
      <br></br>
      {file.path} &nbsp;{file.size} bytes<br></br>

    </>
  ));

  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
      <ul>
        {errors.map((e) => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
    </li>
  ));

  const activeStyle = {
    borderColor: "#2196f3",
  };

  const acceptStyle = {
    borderColor: "#00e676",
  };

  const rejectStyle = {
    borderColor: "#ff1744",
  };

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  return (
    <>
      <section className="container">
        <div {...getRootProps({ style })}>
          <input {...getInputProps()} />
          <p>Drag 'n' drop files here, or click to select files</p>
        </div>
        <aside>
          &nbsp;&nbsp;&nbsp;
          {/* {acceptedFileItems.length > 0 ? <h4>{mts}</h4> : null} */}
          {acceptedFileItems.length > 0 ? <h4>Accepted files</h4> : null}
          {acceptedFileItems.length > 0 ? <h4>{acceptedFileItems}</h4> : null}
          {fileRejectionItems.length > 0 ? <h4>Rejected files</h4> : null}
          {fileRejectionItems.length > 0 ? <h4>{fileRejectionItems}</h4> : null}
        </aside>
        {console.log(acceptedFileItems.length)}
        {/* {localStorage.setItem("manufile", filename)} */}
        {acceptedFileItems.length > 0 && (
          <>
            <br></br>
            <NavLink to="/import_document_loc">
              <button
                type="submit"
                className="inline-flex items-center justify-center rounded-md border border-transparent bg-green-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
              >
                CONTINUE
              </button>
            </NavLink>
          </>
        )}
        {/* <Overview /> */}
        {/* <DDModal isOpen={isOpen} size={size} onClose={onClose} /> */}
      </section>
    </>
  );
}

<CustomValidation />;
